import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import classNames from "classnames";
import React from "react";
import { Typography } from "@parkschannel/ui";
export function CarouselItem(param) {
    let { data  } = param;
    return /*#__PURE__*/ _jsx("div", {
        className: classNames("relative w-[200px] h-[150px] rounded-sm overflow-hidden"),
        children: /*#__PURE__*/ _jsx("div", {
            className: "w-full h-full pr-3",
            children: /*#__PURE__*/ _jsxs("a", {
                href: data.productUrl,
                target: "_blank",
                className: "w-full h-full group",
                children: [
                    data.imageUrl ? /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            /*#__PURE__*/ _jsx("img", {
                                src: data.imageUrl,
                                alt: data.name,
                                className: "object-cover w-full h-full group-hover:scale-105 transition"
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "absolute top-0 left-0 opacity-0 right-3 h-full bg-gradient-to-b from-black/20 to-black/60 group-hover:scale-105 group-hover:opacity-100 transition-all"
                            })
                        ]
                    }) : null,
                    /*#__PURE__*/ _jsx("div", {
                        className: classNames("w-full flex justify-center items-center transition px-2 ", {
                            "absolute top-1/2 left-1/2 -translate-x-1/2 opacity-0 group-hover:opacity-100 group-hover:-translate-y-1/2 ": !!data.imageUrl,
                            "bg-neutral-200  group-hover:bg-neutral-300 h-full": !data.imageUrl
                        }),
                        children: /*#__PURE__*/ _jsx(Typography, {
                            variant: "bodySmall",
                            className: "text-center text-white",
                            children: data.name
                        })
                    })
                ]
            })
        })
    });
}
